import { jsx as _jsx } from "react/jsx-runtime";
import Linkify from 'react-linkify';
import { A } from './preflighted';
import { useTheme } from './providers/DialectThemeProvider';
// Similar to twitter
const MAX_LINK_TEXT_LENGTH = 32;
export default function LinkifiedText({ children }) {
    const { textStyles } = useTheme();
    return (_jsx(Linkify, { componentDecorator: (decoratedHref, decoratedText, key) => (_jsx(A, { target: "blank", className: textStyles.link, href: decoratedHref, children: decoratedText.length > MAX_LINK_TEXT_LENGTH
                ? decoratedText.slice(0, MAX_LINK_TEXT_LENGTH) + '...'
                : decoratedText }, key)), children: children }));
}
//# sourceMappingURL=LinkifiedText.js.map